import React from 'react';
import {
  ArrowLeft,
  ArrowRight,
  BrandIcon,
  ClientIcon,
  DealIcon,
  ItemIcon,
  LogoutBigIcon,
  LogoutIcon,
  PurchaseOrder,
  PurchaseRequestIcon,
  RoleAndPermissionIcon,
  SideBarLogoCollapsedIcon,
  SideBarLogoIcon,
  SupplierIcon,
  UsersIcon,
} from 'components/common/icons';
import { Link } from 'react-router-dom';
import { ADMIN_ROUTES } from 'constants/routes';
import { PERMISSIONS } from 'constants/permissions';
import { TaskIcon } from 'components/common/icons/sideBarIcons/TaskIcon';
import { useAdminSideBar } from 'components/common/adminSideBar/useAdminSideBar';
import { LeadIcon } from 'components/common/icons/sideBarIcons/menuIcon/LeadIcon';
import { CountryIcon } from 'components/common/icons/sideBarIcons/menuIcon/CountryIcon';
import { DashboardIcon } from 'components/common/icons/sideBarIcons/menuIcon/DashboardIcon';
import { Avatar, Button, Col, Divider, Modal, Row, Space, Tooltip, Typography } from 'components';
import { OrderIcon } from '../icons/sideBarIcons/menuIcon/OrderIcon';
import { useAccessControl } from '../accessControl/useAccessControl';
import { UserIcon } from '../icons/sideBarIcons/UserIcon';
import styles from './styles.module.scss';
import { SupplierOffer } from 'components/common/icons/sideBarIcons/menuIcon/SupplierOffer';

const { Text, Title } = Typography;
const navigation1Items = [
  {
    path: ADMIN_ROUTES.dashboardPage,
    label: 'Dashboard',
    icon: <DashboardIcon />,
    id: '1/0',
    // permission: PERMISSIONS.dashboard.dashboard.read,
  },
  {
    path: ADMIN_ROUTES.clients,
    label: 'Clients',
    icon: <ClientIcon />,
    id: '1/1',
    permission: PERMISSIONS.clients.client.read,
  },
  {
    path: ADMIN_ROUTES.brand.list,
    label: 'Brands',
    icon: <BrandIcon />,
    id: '1/2',
    permission: PERMISSIONS.brands.brand.read,
  },
  {
    path: ADMIN_ROUTES.suppliers.list,
    label: 'Suppliers',
    icon: <SupplierIcon />,
    id: '1/3',
    permission: PERMISSIONS.suppliers.supplier.read,
  },
  {
    path: ADMIN_ROUTES.items.list,
    label: 'Items',
    icon: <ItemIcon />,
    id: '1/4',
    permission: PERMISSIONS.items.item.read,
  },
  {
    path: ADMIN_ROUTES.country.list,
    label: 'Countries',
    icon: <CountryIcon />,
    id: '1/5',
    permission: PERMISSIONS.countries.country.read,
  },
];
const navigation2Items = [
  {
    path: ADMIN_ROUTES.leads.list,
    label: 'Leads',
    icon: <LeadIcon />,
    id: '2/1',
    permission: PERMISSIONS.leads.lead.read,
  },
  {
    path: ADMIN_ROUTES.purchaseRequest.list,
    label: 'Purchase Request',
    icon: <PurchaseRequestIcon />,
    id: '2/2',
    permission: PERMISSIONS.purchaseRequests.purchaseRequest.read,
  },
  {
    path: ADMIN_ROUTES.deals.list,
    label: 'Deals',
    icon: <DealIcon />,
    id: '2/3',
    permission: PERMISSIONS.deals.deal.read,
  },
  {
    path: ADMIN_ROUTES.orders.list,
    label: 'Orders',
    icon: <OrderIcon />,
    id: '2/4',
    permission: PERMISSIONS.orders.order.read,
  },

  {
    path: ADMIN_ROUTES.purchaseOrder.list,
    label: 'Purchase Order',
    icon: <PurchaseOrder />,
    id: '2/5',
    permission: PERMISSIONS.purchaseOrders.purchaseOrder.read,
  },
  {
    path: ADMIN_ROUTES.supplierOffer.list,
    label: 'Supplier Offers',
    icon: <SupplierOffer />,
    id: '2/6',
    permission: PERMISSIONS.supplierOffers.supplierOffer.read,
  },
  {
    path: ADMIN_ROUTES.tasks.list,
    label: 'Tasks',
    icon: <TaskIcon />,
    id: '2/7',
    permission: PERMISSIONS.tasks.task.read,
  },
];
const navigation3Items = [
  {
    path: ADMIN_ROUTES.users.list,
    label: 'User Management',
    icon: <UsersIcon />,
    id: '3/1',
    permission: PERMISSIONS.users.user.read,
  },
  {
    path: ADMIN_ROUTES.role.list,
    label: 'Roles and Permissions',
    icon: <RoleAndPermissionIcon />,
    id: '3/2',
    permission: PERMISSIONS.roles.role.read,
  },
];

// just add new action item
const actionMenuItems = [
  {
    label: 'Profile',
    action: 'profile',
    icon: <UserIcon />,
  },
  {
    label: 'Logout',
    action: 'logout',
    icon: <LogoutIcon />,
  },
];

export const AdminSideBar = React.memo(() => {
  const { hasAccess } = useAccessControl();
  const {
    pathname,
    toggleSidebarCollapse,
    collapsed,
    toggleActionMenu,
    actionMenuOpen,
    isModalOpen,
    handleActionMenu,
    handleOk,
    handleCancel,
    contextHolder,
    data,
    navigateHome,
  } = useAdminSideBar();

  return (
    <>
      {contextHolder}
      {!collapsed && <div className={styles.side_bar_backdrop} onClick={toggleSidebarCollapse} />}
      <Row
        className={`${styles.side_bar} ${!collapsed && styles.expanded}`}
        gutter={[0, 24]}
        justify={'center'}
        align={'stretch'}
      >
        <Col span={24}>
          <Col className={'pointer'} onClick={navigateHome}>
            {collapsed ? <SideBarLogoCollapsedIcon /> : <SideBarLogoIcon />}
          </Col>
          <Row gutter={[0, 4]} className={styles.nav_category_container}>
            <Divider className={`${styles.side_bar_divider} ${styles.firs_divider}`} />
            <Col span={24}>
              <Row gutter={[0, 4]} className={styles.nav_items_container} justify={'center'}>
                {navigation1Items
                  .filter((i) => !i.permission || hasAccess(i.permission))
                  .map((_navItem) => {
                    return (
                      <Tooltip
                        // classNames={{ root: 'side-bar-tooltip' }}
                        placement="rightTop"
                        arrow={false}
                        key={_navItem.id}
                        title={collapsed ? _navItem.label : null}
                      >
                        <Link
                          to={_navItem.path}
                          className={`${styles.nav_item} ${pathname.startsWith(_navItem.path) && styles.active}`}
                        >
                          {_navItem.icon}
                          {!collapsed && <Text className={'font-weight-500'}>{_navItem.label}</Text>}
                        </Link>
                      </Tooltip>
                    );
                  })}
              </Row>
            </Col>
            <Divider className={styles.side_bar_divider} />
            <Col span={24}>
              <Row gutter={[0, 4]} className={styles.nav_items_container} justify={'center'}>
                {navigation2Items
                  .filter((i) => !i.permission || hasAccess(i.permission))
                  .map((_navItem) => {
                    return (
                      <Tooltip
                        // classNames={{ root: 'side-bar-tooltip' }}
                        placement="rightTop"
                        arrow={false}
                        key={_navItem.id}
                        title={collapsed ? _navItem.label : null}
                      >
                        <Link
                          to={_navItem.path}
                          className={`${styles.nav_item} ${pathname.startsWith(_navItem.path) && styles.active}`}
                        >
                          {_navItem.icon}
                          {!collapsed && <Text className={'font-weight-500'}>{_navItem.label}</Text>}
                        </Link>
                      </Tooltip>
                    );
                  })}
              </Row>
            </Col>
            <Divider className={styles.side_bar_divider} />
            <Col span={24}>
              <Row gutter={[0, 4]} className={styles.nav_items_container} justify={'center'}>
                {navigation3Items
                  .filter((i) => hasAccess(i.permission))
                  .map((_navItem) => {
                    return (
                      <Tooltip
                        // classNames={{ root: 'side-bar-tooltip' }}
                        placement="rightTop"
                        arrow={false}
                        key={_navItem.id}
                        title={collapsed ? _navItem.label : null}
                      >
                        <Link
                          to={_navItem.path}
                          className={`${styles.nav_item} ${pathname.startsWith(_navItem.path) && styles.active}`}
                        >
                          {_navItem.icon}
                          {!collapsed && (
                            <Text style={{ color: '#99A0AE' }} className={'font-weight-500'}>
                              {_navItem.label}
                            </Text>
                          )}
                        </Link>
                      </Tooltip>
                    );
                  })}
              </Row>
            </Col>
          </Row>
        </Col>
        <Col span={24} className={styles.avatar}>
          <Row justify={'space-between'} align={'middle'}>
            <Col span={24} style={{ cursor: 'pointer' }} onClick={toggleActionMenu}>
              <Row align={'middle'} style={{ cursor: 'pointer' }} className={'gap-8'}>
                <Col className={`${collapsed && styles.avatar_icon_container}`}>
                  <Avatar
                    size={40}
                    src={data.files?.AVATAR}
                    style={{ backgroundColor: '#525866', border: 'none', fontSize: '14px' }}
                  >
                    {data.firstName?.charAt(0)}
                    {data.lastName?.charAt(0)}
                  </Avatar>
                </Col>

                {!collapsed && (
                  <Space size={2}>
                    <Text
                      ellipsis={true}
                      className={'font-weight-600'}
                      style={{ maxWidth: 210, color: '#FFFFFF', display: 'inline-block' }}
                    >
                      {data.firstName ? data.firstName : ''} {data.lastName ? data.lastName : ''}
                    </Text>
                  </Space>
                )}
              </Row>
            </Col>
            {actionMenuOpen && <div className={styles.backdrop} onClick={toggleActionMenu} />}
            {actionMenuOpen && (
              <Row
                className={styles.action_menu}
                style={{
                  ...(collapsed ? { left: 'calc(100% - 5px)' } : { right: '5px' }),
                }}
              >
                {actionMenuItems.map((_actionItem) => (
                  <Col
                    key={_actionItem.label}
                    className={styles.action_item}
                    span={24}
                    onClick={() => handleActionMenu(_actionItem.action)}
                  >
                    <Row className={'gap-6'} align={'middle'}>
                      {_actionItem.icon}
                      <Text>{_actionItem.label}</Text>
                    </Row>
                  </Col>
                ))}
              </Row>
            )}
          </Row>
        </Col>
        <Button
          onClick={toggleSidebarCollapse}
          className={styles.collapse_button}
          variant={'filled'}
          size={'middle'}
          shape="circle"
          style={{ border: 'none', boxShadow: 'none' }}
          icon={collapsed ? <ArrowRight /> : <ArrowLeft />}
        ></Button>
      </Row>
      <Modal
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        closable={false}
        width={'360'}
        centered
        footer={() => (
          <Row wrap={false} className={'gap-8'} style={{ marginTop: '24px' }}>
            <Button block size={'large'} onClick={handleCancel}>
              Cancel
            </Button>
            <Button block size={'large'} type="primary" onClick={handleOk}>
              Log Out
            </Button>
          </Row>
        )}
      >
        <Row gutter={[0, 12]} align={'middle'} justify={'center'} className={styles.modal_info}>
          <LogoutBigIcon />
          <Col span={24} className={'center'}>
            <Title level={3} className={'reset-title'}>
              Log Out
            </Title>
          </Col>
          <Text style={{ color: '#525866' }}>Are you sure you want to log out?</Text>
        </Row>
      </Modal>
    </>
  );
});
